import { useState } from "react";
import { css } from "@emotion/react";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import { CheckboxV2 } from "src/components/CheckboxV2/CheckboxV2.tsx";

import { ModalV3 } from "src/components/ModalV3/ModalV3.tsx";

import { type PriceListResource } from "@exonn/js-sdk";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";

type PriceListsModalProps = {
  onClose: () => void;
  priceLists: PriceListResource[];
  selectedPriceListIds: string[];
  onSave: ({
    tempSelectedPriceListIds,
  }: {
    tempSelectedPriceListIds: string[];
  }) => void;
};

await loadTranslations(TranslationNamespaceEnum.SelectPriceListsModal);

export function SelectPriceLists(props: PriceListsModalProps) {
  const { onClose, priceLists, selectedPriceListIds, onSave } = props;
  const { t } = useTranslation(TranslationNamespaceEnum.SelectPriceListsModal);

  const [tempSelectedPriceListIds, setTempSelectedPriceListIds] =
    useState(selectedPriceListIds);

  const handleCheckboxChange = (id: string) => () => {
    setTempSelectedPriceListIds((prev) => {
      const exist = prev.includes(id);
      if (exist) {
        return prev.filter((prevId) => prevId !== id);
      }
      return [id, ...prev];
    });
  };

  const handleSave = () => {
    onSave({
      tempSelectedPriceListIds,
    });
  };

  return (
    <ModalV3 onClose={onClose}>
      <ModalV3.Positioner>
        <ModalV3.Content>
          <ModalV3.CloseTrigger />
          <ModalV3.Header>
            <ModalV3.Title>{t("title")}</ModalV3.Title>
          </ModalV3.Header>

          <ModalV3.Body>
            <div css={containerStyles}>
              {priceLists.map((priceList) => (
                <CheckboxV2
                  key={priceList.id}
                  label={priceList.title}
                  checked={tempSelectedPriceListIds.includes(priceList.id)}
                  onChange={handleCheckboxChange(priceList.id)}
                />
              ))}
            </div>
          </ModalV3.Body>
          <ModalV3.Footer>
            <ModalV3.FooterButtons>
              <ButtonV2 skin="info" variant="outlined" onClick={onClose}>
                {t("close_button")}
              </ButtonV2>
              <ButtonV2 skin="info" variant="filled" onClick={handleSave}>
                {t("save_button")}
              </ButtonV2>
            </ModalV3.FooterButtons>
          </ModalV3.Footer>
        </ModalV3.Content>
      </ModalV3.Positioner>
    </ModalV3>
  );
}

const containerStyles = css({
  display: "flex",
  flexDirection: "column",
  width: 528,
  gap: 15,
});
